import React, { useId } from 'react'
import PropTypes from 'prop-types'

const EyeIcon = React.forwardRef(function EyeIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M23.01 11.55C22.88 11.29 19.65 5 12.12 5C4.59 5 1.36 11.29 1.22 11.55L1 12L1.22 12.45C1.36 12.71 4.59 19 12.12 19C19.65 19 22.88 12.71 23.01 12.45L23.24 12L23.01 11.55ZM12.12 17C6.85 17 4.09 13.31 3.27 12C3.8 11.15 5.16 9.29 7.5 8.09C7.26 8.68 7.12 9.33 7.12 10C7.12 12.76 9.36 15 12.12 15C14.88 15 17.12 12.76 17.12 10C17.12 9.33 16.98 8.68 16.74 8.09C19.07 9.28 20.44 11.14 20.97 12C20.15 13.31 17.39 17 12.12 17Z"></path>
    </svg>
  )
})

EyeIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

EyeIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default EyeIcon
